import PageTemplate from '../components/common/PageTemplate';
import SetLocationAddress from '../screen/locationAddress/SetLocationAddress';

const SetLocationPage = () => {
  return (
    <PageTemplate
      mainComponent={<SetLocationAddress />}
      noPadding={true}
      logo="Atur Lokasi & Pengiriman"
    />
  );
}

export default SetLocationPage
